// Libs
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Utils
import { filterOption } from 'utils/libs';
import { formatArticlesData } from 'utils/libs/dateFormats';
// Context
import { ModalBuilderContext } from 'core/context';
// Actions
import { sendToast } from 'screens/Dashboard/actions';
// Selectors
import { selectProfile } from 'screens/Login/selectors';
// Hooks
import useOrderApi from 'core/hooks/useCoreApi';
// Components
import {
	Wrapper,
	Modal,
	Title,
	LogoIcon,
	Button,
	Select,
	InputNumber,
} from 'components';
import { Input } from 'antd';

const ArticleOption = ({ mainState, setMainState }) => {
	return (
		<Select
			margin='0 0 5px 0'
			autofocus
			showSearch
			placeholder='Artículo*'
			value={mainState.selectedItemId}
			filterOption={filterOption}
			onChange={value => setMainState({ selectedItemId: value })}
		>
			{mainState.articles.map((art, idx) => (
				<Select.Option key={idx} value={art.item_id}>
					<em>{`${art.item}-${art.name}`}</em>
				</Select.Option>
			))}
		</Select>
	);
};

const AmountOption = ({ mainState, setMainState }) => (
	<InputNumber
		margin='0 0 10px 0'
		placeholder='Cantidad*'
		min={0.01}
		value={mainState.amount}
		onChange={value =>
			setMainState({
				amount: Math.floor(value === null || value < 1 ? 1 : value),
			})
		}
	/>
);

const SerieOption = ({ mainState, setMainState }) => (
	<Input
		maxLength={45}
		margin='0 0 10px 0'
		value={mainState.serie}
		placeholder='Serie'
		onChange={e => setMainState({ serie: e.target.value })}
	/>
);

const CreateNewArticle = () => {
	const [mainState, _setMainState] = useState({
		selectedItemId: undefined,
		articles: [],
		amount: undefined,
		serie: undefined,
	});
	const [isFetching, setIsFetching] = useState(false);

	const { getArticles } = useOrderApi();

	const setMainState = newState =>
		_setMainState(currentState => ({ ...currentState, ...newState }));

	const { payload: modalPayload, cleanModal } = useContext(ModalBuilderContext);

	const profile = useSelector(selectProfile);

	const { stateTable, getData, wtdId } = modalPayload;

	const { addNewArticleToWTD } = useOrderApi();

	const dispatch = useDispatch();

	const sendMessage = ({ message, type = 'warn' }) =>
		dispatch(
			sendToast({
				message,
				type,
				duration: 2,
			}),
		);

	useEffect(() => {
		getArticles().then(response => {
			const articlesData = response.map(row =>
				formatArticlesData(
					row,
					profile.organization.tz,
					profile.user.settings.date_format,
				),
			);
			setMainState({
				articles: articlesData.filter(article => !article.is_serialized),
			});
		});
	}, []);

	const onCreateNewArticle = () => {
		const warnsMessage = {
			isInValidated: 'Debe completar los campos requeridos [*]',
			isfoundArt: 'El artículo ya fue añadido',
		};

		const value = mainState.amount || mainState.serie;
		const isInValidated = !mainState.selectedItemId || !value;

		const isfoundArt = !!stateTable.find(
			art => art.itemId === mainState.selectedItemId,
		);

		if (isInValidated || isfoundArt) {
			const selectedMessage =
				(isInValidated && 'isInValidated') || (isfoundArt && 'isfoundArt');

			return sendMessage({ message: warnsMessage[selectedMessage] });
		}

		setIsFetching(current => !current);

		addNewArticleToWTD({
			itemId: mainState.selectedItemId,
			amount: mainState.amount,
			serie: mainState.serie,
			wtdId,
		})
			.then(() => {
				getData();

				setIsFetching(current => !current);

				cleanModal();
			})
			.catch(({ message }) => {
				sendMessage({ message, type: 'error' });
				setIsFetching(current => !current);
			});
	};

	return (
		<Modal
			title={null}
			closable={false}
			centered={false}
			visible={true}
			onCancel={cleanModal}
			footer={null}
		>
			<Wrapper
				highBackground
				width='100%'
				margin='0'
				flexDirection='column'
				alignItems='center'
				justifyContent='flex-start'
			>
				<Title>Nueva Artículo</Title>

				<Wrapper
					padding='0'
					width={1200}
					flexDirection='column'
					alignItems='stretch'
				>
					<ArticleOption mainState={mainState} setMainState={setMainState} />
					<AmountOption mainState={mainState} setMainState={setMainState} />
					<SerieOption mainState={mainState} setMainState={setMainState} />
				</Wrapper>

				<Wrapper
					padding='0'
					margin='10px 0 0 0'
					width={1200}
					flexDirection='column'
					alignItems='center'
				>
					{isFetching ? (
						<LogoIcon spin />
					) : (
						<Button mode='primary' onClick={onCreateNewArticle}>
							Agregar
						</Button>
					)}
				</Wrapper>
			</Wrapper>
		</Modal>
	);
};

export default CreateNewArticle;
